import type { FileTransferTask } from './types';

const terminalStatuses = new Set(['completed', 'failed']);

export function fileTransferSyncSignal(tasks: FileTransferTask[]): string {
  // Only local online terminal transitions wake the authoritative projection
  // refresh. Device-local progress must not trigger a request per chunk/update.
  return tasks
    .filter((task) => task.transport === 'online' && terminalStatuses.has(task.status))
    .map((task) => `${task.taskId}:${task.status}`)
    .sort()
    .join('|');
}
